import { ArrowLeft } from 'iconoir-react';
import { SlidersHorizontal } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import { sidebarNavItemLabelClass, sidebarNavItemLabelActiveClass } from './sidebar-nav-label';
import {
  sidebarNavIconClass,
  SIDEBAR_NAV_ICON_SIZE,
  SIDEBAR_NAV_ICON_STROKE,
} from './sidebar-nav-icon';
import {
  sidebarNavItemClassName,
  sidebarNavItemActiveClassName,
  sidebarNavItemIconOnlyClassName,
} from './sidebar-nav-item-styles';
import { SidebarNavTooltip } from './sidebar-nav-tooltip';

interface SidebarConfigureNavItemProps {
  showText?: boolean;
  isActive?: boolean;
  onClick?: () => void;
  showAsBack?: boolean;
}

export function SidebarConfigureNavItem({
  showText = true,
  isActive = false,
  onClick,
  showAsBack = false,
}: SidebarConfigureNavItemProps) {
  const { t } = useTranslation();
  const label = t('ADVANCED') || 'Advanced';
  const Icon = showAsBack ? ArrowLeft : SlidersHorizontal;

  return (
    <SidebarNavTooltip label={label} enabled={!showText}>
      <button
        type="button"
        onClick={onClick}
        className={cn(
          sidebarNavItemClassName,
          !showText && sidebarNavItemIconOnlyClassName,
          isActive && sidebarNavItemActiveClassName
        )}
        aria-label={label}
        aria-current={isActive ? 'page' : undefined}
      >
        <Icon
          width={SIDEBAR_NAV_ICON_SIZE}
          height={SIDEBAR_NAV_ICON_SIZE}
          strokeWidth={SIDEBAR_NAV_ICON_STROKE}
          className={sidebarNavIconClass}
        />
        {showText && (
          <span className={cn(sidebarNavItemLabelClass, isActive && sidebarNavItemLabelActiveClass, 'truncate')}>{label}</span>
        )}
      </button>
    </SidebarNavTooltip>
  );
}
